import { SprintStatus } from 'src/types/sprint';

export const SPRINTS_ROUTE_KEY = 'sprints';
export const SPRINT_LIST_TITLE_KEY = 'sprint_list_title';
export const SPRINT_LIST_CREATE_BUTTON_KEY = 'create_sprint';
export const SPRINT_LIST_EMPTY_STATE_TITLE_KEY =
  'sprint_list_empty_state_title';
export const SPRINT_LIST_EMPTY_STATE_SUBTITLE_KEY =
  'sprint_list_empty_state_subtitle';
export const SPRINT_FORM_DIALOG_TITLE_CREATE_KEY = 'sprint_form_create_title';
export const SPRINT_FORM_DIALOG_TITLE_EDIT_KEY = 'sprint_form_edit_title';
export const SPRINT_FORM_NAME_LABEL_KEY = 'sprint_form_name_label';
export const SPRINT_FORM_START_DATE_LABEL_KEY = 'sprint_form_start_date_label';
export const SPRINT_FORM_END_DATE_LABEL_KEY = 'sprint_form_end_date_label';
export const SPRINT_FORM_GOAL_LABEL_KEY = 'sprint_form_goal_label';
export const SPRINT_FORM_CAPACITY_LABEL_KEY = 'sprint_form_capacity_label';
export const SPRINT_FORM_STATUS_LABEL_KEY = 'sprint_form_status_label';
export const SPRINT_FORM_SUBMIT_LABEL_KEY = 'sprint_form_submit_label';
export const SPRINT_FORM_CANCEL_LABEL_KEY = 'sprint_form_cancel_label';
export const SPRINT_FORM_START_BEFORE_END_ERROR_KEY =
  'sprint_form_start_before_end_error';
export const SPRINT_FORM_ACTIVE_EXISTS_ERROR_KEY =
  'sprint_form_active_exists_error';
export const SPRINT_FORM_MODIFICATION_ERROR_KEY =
  'sprint_form_modification_error';
export const SPRINT_ASSIGN_CONFIRMATION_TITLE_KEY =
  'sprint_assign_confirmation_title';
export const SPRINT_REMOVE_CONFIRMATION_TITLE_KEY =
  'sprint_remove_confirmation_title';
export const SPRINT_ASSIGN_CONFIRMATION_MESSAGE_KEY =
  'sprint_assign_confirmation_message';
export const SPRINT_REMOVE_CONFIRMATION_MESSAGE_KEY =
  'sprint_remove_confirmation_message';
export const SPRINT_ASSIGN_CONFIRMATION_CONFIRM_KEY =
  'sprint_assign_confirmation_confirm';
export const SPRINT_REMOVE_CONFIRMATION_CONFIRM_KEY =
  'sprint_remove_confirmation_confirm';
export const SPRINT_CONFIRMATION_CANCEL_KEY = 'sprint_confirmation_cancel';
export const SPRINT_LIST_TABLE_NAME_COLUMN_KEY = 'sprint_list_column_name';
export const SPRINT_LIST_TABLE_STATUS_COLUMN_KEY = 'sprint_list_column_status';
export const SPRINT_LIST_TABLE_START_COLUMN_KEY =
  'sprint_list_column_start_date';
export const SPRINT_LIST_TABLE_END_COLUMN_KEY = 'sprint_list_column_end_date';
export const SPRINT_LIST_TABLE_CAPACITY_COLUMN_KEY =
  'sprint_list_column_capacity';
export const SPRINT_LIST_TABLE_ACTIONS_COLUMN_KEY =
  'sprint_list_column_actions';
export const SPRINT_LIST_TABLE_TOTAL_TASKS_COLUMN_KEY =
  'sprint_list_column_total_tasks';
export const SPRINT_BOARD_TABLE_TITLE_COLUMN_KEY = 'sprint_board_column_title';
export const SPRINT_BOARD_TABLE_STATUS_COLUMN_KEY =
  'sprint_board_column_status';
export const SPRINT_BOARD_TABLE_ASSIGNEES_COLUMN_KEY =
  'sprint_board_column_assignees';
export const SPRINT_BOARD_TABLE_STORY_POINTS_COLUMN_KEY =
  'sprint_board_column_story_points';
export const SPRINT_BOARD_TABLE_DUE_DATE_COLUMN_KEY =
  'sprint_board_column_due_date';
export const SPRINT_BOARD_TABLE_HEALTH_COLUMN_KEY =
  'sprint_board_column_health';
export const SPRINT_LIST_SEARCH_PLACEHOLDER_KEY =
  'sprint_list_search_placeholder';
export const SPRINT_BOARD_SEARCH_PLACEHOLDER_KEY =
  'sprint_board_search_placeholder';
export const SPRINT_BOARD_ASSIGNEE_FILTER_LABEL_KEY = 'assignees';
export const SPRINT_BOARD_ASSIGNEES_QUERY_KEY = 'assignees';
export const SPRINT_BOARD_ASSIGNEES_DELIMITER = ',';
export const SPRINT_BOARD_VIEW_BACKLOG_KEY = 'sprint_board_view_backlog';
export const SPRINT_BOARD_TITLE_KEY = 'sprint_board_title';
export const SPRINT_BOARD_SUMMARY_TITLE_KEY = 'sprint_board_summary_title';
export const SPRINT_BOARD_BACK_TO_LIST_KEY = 'sprint_board_back_to_list';
export const SPRINT_TOTAL_PLANNED_LABEL_KEY = 'sprint_total_planned_label';
export const SPRINT_TOTAL_ACTIVE_LABEL_KEY = 'sprint_total_active_label';
export const SPRINT_TOTAL_COMPLETED_LABEL_KEY = 'sprint_total_completed_label';
export const SPRINT_TOTAL_ARCHIVED_LABEL_KEY = 'sprint_total_archived_label';
export const SPRINT_BOARD_TOTAL_TASKS_LABEL_KEY =
  'sprint_board_total_tasks_label';
export const SPRINT_BOARD_PROGRESS_LABEL_KEY = 'sprint_board_progress_label';
export const SPRINT_BOARD_AUTO_MANAGE_SETTINGS_LABEL_KEY =
  'sprint_board_auto_manage_settings_label';
export const SPRINT_BOARD_AUTO_MANAGE_SPACE_LABEL_KEY =
  'sprint_board_auto_manage_space_label';
export const SPRINT_BOARD_AUTO_MANAGE_HOURS_LABEL_KEY =
  'sprint_board_auto_manage_hours_label';
export const SPRINT_BOARD_AUTO_MANAGE_OFF_LABEL_KEY =
  'sprint_board_auto_manage_off_label';
export const SPRINT_BOARD_AUTO_MANAGE_LAST_RUN_LABEL_KEY =
  'sprint_board_auto_manage_last_run_label';
export const SPRINT_BOARD_AUTO_MANAGE_LAST_SUMMARY_LABEL_KEY =
  'sprint_board_auto_manage_last_summary_label';
export const SPRINT_BOARD_HEALTH_OVERDUE_LABEL_KEY =
  'sprint_board_health_overdue_label';
export const SPRINT_BOARD_HEALTH_NEEDS_UPDATE_LABEL_KEY =
  'sprint_board_health_needs_update_label';
export const SPRINT_BOARD_STORY_POINTS_LABEL_KEY =
  'sprint_board_story_points_label';
export const SPRINT_BOARD_REMAINING_STORY_POINTS_LABEL_KEY =
  'sprint_board_remaining_story_points_label';
export const SPRINT_BOARD_CAPACITY_LABEL_KEY = 'sprint_board_capacity_label';
export const SPRINT_BOARD_OVER_CAPACITY_LABEL_KEY =
  'sprint_board_over_capacity_label';
export const SPRINT_BACKLOG_TITLE_KEY = 'sprint_backlog_title';
export const SPRINT_BACKLOG_BACK_TO_BOARD_KEY = 'sprint_backlog_back_to_board';
export const SPRINT_BACKLOG_ASSIGN_BUTTON_KEY = 'sprint_backlog_assign_button';
export const SPRINT_BACKLOG_REMOVE_BUTTON_KEY = 'sprint_backlog_remove_button';
export const SPRINT_BACKLOG_SEARCH_PLACEHOLDER_KEY =
  'sprint_backlog_search_placeholder';
export const SPRINT_BACKLOG_EMPTY_STATE_TITLE_KEY =
  'sprint_backlog_empty_state_title';
export const SPRINT_BACKLOG_EMPTY_STATE_SUBTITLE_KEY =
  'sprint_backlog_empty_state_subtitle';
export const SPRINT_BACKLOG_TABLE_TITLE_COLUMN_KEY =
  'sprint_backlog_column_title';
export const SPRINT_BACKLOG_TABLE_STATUS_COLUMN_KEY =
  'sprint_backlog_column_status';
export const SPRINT_BACKLOG_TABLE_ASSIGNEES_COLUMN_KEY =
  'sprint_backlog_column_assignees';
export const SPRINT_BACKLOG_TABLE_STORY_POINTS_COLUMN_KEY =
  'sprint_backlog_column_story_points';
export const SPRINT_BACKLOG_TABLE_DUE_DATE_COLUMN_KEY =
  'sprint_backlog_column_due_date';
export const SPRINT_BULK_ASSIGN_SUCCESS_KEY =
  'sprint_bulk_assign_success_message';
export const SPRINT_BULK_REMOVE_SUCCESS_KEY =
  'sprint_bulk_remove_success_message';
export const SPRINT_STATUS_FILTER_LABEL_KEY = 'sprint_status_filter_label';
export const SPRINT_STATUS_PLANNED_KEY = 'sprint_status_planned';
export const SPRINT_STATUS_ACTIVE_KEY = 'sprint_status_active';
export const SPRINT_STATUS_COMPLETED_KEY = 'sprint_status_completed';
export const SPRINT_STATUS_ARCHIVED_KEY = 'sprint_status_archived';
export const SPRINT_STATUS_LABEL_KEYS: Record<SprintStatus, string> = {
  [SprintStatus.PLANNED]: SPRINT_STATUS_PLANNED_KEY,
  [SprintStatus.ACTIVE]: SPRINT_STATUS_ACTIVE_KEY,
  [SprintStatus.COMPLETED]: SPRINT_STATUS_COMPLETED_KEY,
  [SprintStatus.ARCHIVED]: SPRINT_STATUS_ARCHIVED_KEY,
};

export const SPRINT_STATUS_CHIP_COLORS: Record<
  SprintStatus,
  'default' | 'primary' | 'success' | 'warning' | 'info'
> = {
  [SprintStatus.PLANNED]: 'default',
  [SprintStatus.ACTIVE]: 'info',
  [SprintStatus.COMPLETED]: 'success',
  [SprintStatus.ARCHIVED]: 'default',
};

export const SPRINT_STATUS_TRANSITIONS: Record<SprintStatus, SprintStatus[]> = {
  [SprintStatus.PLANNED]: [
    SprintStatus.ACTIVE,
    SprintStatus.COMPLETED,
    SprintStatus.ARCHIVED,
  ],
  [SprintStatus.ACTIVE]: [SprintStatus.COMPLETED, SprintStatus.ARCHIVED],
  [SprintStatus.COMPLETED]: [SprintStatus.ARCHIVED],
  [SprintStatus.ARCHIVED]: [],
};

export const SPRINT_STATUS_OPTIONS = [
  SprintStatus.PLANNED,
  SprintStatus.ACTIVE,
  SprintStatus.COMPLETED,
  SprintStatus.ARCHIVED,
];

export const SPRINT_ACTION_VIEW_BOARD_KEY = 'sprint_action_view_board';
export const SPRINT_ACTION_EDIT_KEY = 'sprint_action_edit';
export const SPRINT_ACTION_ARCHIVE_KEY = 'sprint_action_archive';
export const SPRINT_ACTION_DELETE_KEY = 'sprint_action_delete';
export const SPRINT_ACTION_START_KEY = 'sprint_action_start';
export const SPRINT_ACTION_COMPLETE_KEY = 'sprint_action_complete';
export const SPRINT_ACTION_REOPEN_KEY = 'sprint_action_reopen';
export const SPRINT_ACTION_CANCEL_KEY = 'sprint_action_cancel';
export const SPRINT_STATUS_UPDATE_SUCCESS_KEY = 'sprint_status_update_success';
export const SPRINT_DELETE_SUCCESS_KEY = 'sprint_delete_success';
export const SPRINT_SAVE_SUCCESS_KEY = 'sprint_save_success';
export const SPRINT_BOARD_ADD_FROM_BACKLOG_KEY =
  'sprint_board_add_from_backlog';
export const SPRINT_BOARD_REMOVE_SELECTED_KEY = 'sprint_board_remove_selected';
export const SPRINT_ACTIVE_SUMMARY_TITLE_KEY = 'sprint_active_summary_title';
export const SPRINT_ACTIVE_SUMMARY_EMPTY_TITLE_KEY =
  'sprint_active_summary_empty_title';
export const SPRINT_ACTIVE_SUMMARY_EMPTY_SUBTITLE_KEY =
  'sprint_active_summary_empty_subtitle';
export const SPRINT_ACTIVE_SUMMARY_TOTAL_TASKS_LABEL_KEY =
  'sprint_active_summary_total_tasks_label';
export const SPRINT_ACTIVE_SUMMARY_PROGRESS_LABEL_KEY =
  'sprint_active_summary_progress_label';
export const SPRINT_ACTIVE_SUMMARY_STORY_POINTS_LABEL_KEY =
  'sprint_active_summary_story_points_label';
export const SPRINT_ACTIVE_SUMMARY_VIEW_BOARD_BUTTON_KEY =
  'sprint_active_summary_view_board_button';

export const SPRINT_MAX_NAME_LENGTH = 120;
export const SPRINT_DEFAULT_PAGE = 1;
export const SPRINT_DEFAULT_LIMIT = 10;
export const SPRINT_BACKLOG_DEFAULT_LIMIT = 10;
export const SPRINT_STATUS_FILTER_ALL = 'ALL';
export const SPRINT_SORT_ORDER_ASCENDING = 'ascending';
export const SPRINT_SORT_ORDER_DESCENDING = 'descending';
export const SPRINT_LIST_DEFAULT_SORT_FIELD = 'startDate';
export const SPRINT_LIST_DEFAULT_SORT_ORDER = SPRINT_SORT_ORDER_DESCENDING;
export const SPRINT_BOARD_DEFAULT_SORT_FIELD = 'status';
export const SPRINT_BOARD_DEFAULT_SORT_ORDER = SPRINT_SORT_ORDER_ASCENDING;
export const SPRINT_BACKLOG_DEFAULT_SORT_FIELD = 'title';
export const SPRINT_BACKLOG_DEFAULT_SORT_ORDER = SPRINT_SORT_ORDER_ASCENDING;
export const SPRINT_SEARCH_DEBOUNCE_MS = 300;
export const SPRINT_DISPLAY_DATE_FORMAT = 'MMM D, YYYY';
export const SPRINT_LIST_PAGE_SIZE_OPTIONS = [10, 25, 50];
export const SPRINT_BOARD_SEARCH_MAX_WIDTH = 360;
export const SPRINT_BOARD_ASSIGNEE_FILTER_MAX_WIDTH = 360;
export const SPRINT_BACKLOG_DRAWER_WIDTH = '80vw';
export const SPRINT_BACKLOG_KEEP_SELECTED_ROWS = true;
export const SPRINT_BACKLOG_TABLE_HEIGHT = 520;
export const SPRINT_TASK_TITLE_COLUMN_FLEX = 1.4;
export const SPRINT_TASK_TITLE_COLUMN_MIN_WIDTH = 320;

// Product readiness gate: sprint auto-management UI is disabled until launch.
export const SPRINT_AUTO_MANAGE_UI_ENABLED = false;
